import React, { PureComponent } from 'react';
import moment from 'moment';

export default class GanttChartScaleYears extends PureComponent {
    getNextYearFirstDay(date) {
        const index = this.chartDays.findIndex(day => day.clone().startOf('year').diff(date.clone().startOf('year'), 'years') > 0);

        if (index === -1) {
            return this.chartDays.length;
        }

        return index;
    }

    getNextMonthFirstDay(date) {
        const index = this.chartDays.findIndex(day => day.clone().startOf('month').diff(date.clone().startOf('month'), 'months') > 0);

        if (index === -1) {
            return this.chartDays.length;
        }

        return index;
    }

    getMonthDays(date) {
        return date.daysInMonth();
    }

    get chartDays() {
        return new Array(this.props.chartDuration).fill(0).map((item, index) => this.props.chartStart.clone().add(index, 'days'));
    }

    render() {
        if (!this.props.chartStart || !this.props.chartDuration) {
            return null;
        }

        let secLastDay;
        let lastDay;

        return (
            <div className="gantt-chart-scale">
                <div className="scale-items-secondary">
                    {
                        this.chartDays.map((date, index) => {
                            if (secLastDay && date.isSame(secLastDay, 'year')) {
                                return null;
                            }

                            secLastDay = date;

                            const startPx = index * this.props.scaleItemWidth;
                            const endPx = this.getNextYearFirstDay(date) * this.props.scaleItemWidth;

                            return <div className="scale-item-secondary" key={index} style={{left: `${startPx}px`, width: `${endPx - startPx}px`}}>{moment(date).format('YYYY')}</div>
                        })
                    }
                </div>

                <div className="scale-items">
                    {
                        this.chartDays.map((date, index) => {
                            if (lastDay && date.isSame(lastDay, 'month')) {
                                return null;
                            }

                            lastDay = date;

                            return (
                                <div className={'scale-item' + (date.isSame(moment(), 'month') ? ' today': '')} key={index} style={{width: `${this.props.scaleItemWidth * this.getMonthDays(date)}px`}}>
                                    <div className="scale-item-inner">
                                        <span>{date.format('MMMM').toUpperCase()[0]}</span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}
